export default "__VITE_ASSET__xCUpaIoO__"